export class GA4GHSearchRequest {

    additionalCallSetIds = [];
    alleleCount = '';
    annotationFieldThresholds?: AnnotationFieldThresholds = [];
    callSetIds = [];
    discriminate = [];
    end = -1;
    geneName = '';
    getGT = false;
    gtPattern = [];
    gtPattern2 = 'Any';
    maxHeZ = [];
    maxMaf = [];
    maxMissingData = [];
    minHeZ = [];
    minMaf = [];
    minMissingData = [];
    mostSameRatio = [];
    pageSize = 100;
    pageToken = '0';
    referenceName = '';
    searchMode = 3;
    selectedVariantIds = '';
    selectedVariantTypes = '';
    sortBy = '';
    sortDir = 'asc';
    start = -1;
    variantEffect = '';
    variantSetId: string;
}

export interface AnnotationFieldThresholds {
}
